export default {
    'CIRCLE': {
        'FUTURE_PLANNED': {
            title: () => { return 'Planlagte mandedage'; },
            unit: '',
        },
        // 'CALENDARMONTH_PLANNED': {
        //     title: (month) => { return `Hours planned in ${month}`; },
        //     unit: '',
        // },
    },
    'EMPLOYEE': {
        'FUTURE_PLANNED': {
            title: () => { return 'Gruppe statistik'; },
            unit: '',
        },
        // 'CALENDARMONTH_PLANNED': {
        //     title: (month) => { return `Hours planned in ${month}`; },
        //     unit: '',
        // },
        // '30_DAYS_CAPACITY': {
        //     title: () => { return `Capacity today + 30 days`; },
        //     unit: '%',
        // },
    },
  }